import InnerPageLayout from "../../components/feature/InnerPageLayout";

const values = [
  {
    icon: "ri-lightbulb-flash-line",
    color: "#A855F7",
    glow: "rgba(168,85,247,0.15)",
    title: "창의성을 자본으로",
    desc: "예술적 재능은 그 자체로 강력한 비즈니스 자산입니다. 우리는 창의성이 안정적인 수익 구조로 전환될 수 있다고 믿습니다.",
  },
  {
    icon: "ri-shake-hands-line",
    color: "#14F1D9",
    glow: "rgba(20,241,217,0.12)",
    title: "공동 성장의 철학",
    desc: "아르트레너는 단순 서비스 공급자가 아닙니다. 아티스트와 함께 리스크를 지고, 함께 성과를 나누는 진정한 파트너입니다.",
  },
  {
    icon: "ri-eye-line",
    color: "#F97316",
    glow: "rgba(249,115,22,0.12)",
    title: "투명한 구조",
    desc: "수익 쉐어율, 운영 실비, 계약 조건 모두 100% 공개합니다. 숨겨진 수수료나 불투명한 정산은 없습니다.",
  },
  {
    icon: "ri-code-s-slash-line",
    color: "#C084FC",
    glow: "rgba(192,132,252,0.12)",
    title: "테크로 가속하다",
    desc: "D2C 플랫폼, 자동화된 정산 시스템, 데이터 기반 마케팅. 기술이 예술가의 성장을 10배 빠르게 만듭니다.",
  },
];

const team = [
  {
    name: "정은현",
    role: "Co-Founder",
    color: "#A855F7",
    glow: "rgba(168,85,247,0.15)",
    border: "rgba(168,85,247,0.25)",
    img: "https://storage.readdy-site.link/project_files/362f3206-c32d-4165-9763-523bbd9d0cd3/19b837b4-5096-43d8-b318-4dd3a116ce51_-2026-03-19-221608.png?v=d692200ed230837e554bc42b34c76800",
    desc: "직접 창작하며 살아온 예술가. 아티스트가 왜 비즈니스 앞에서 막히는지 누구보다 잘 압니다. 그 경험이 아르트레너의 시작이었습니다.",
  },
  {
    name: "송원영",
    role: "Co-Founder",
    color: "#14F1D9",
    glow: "rgba(20,241,217,0.12)",
    border: "rgba(20,241,217,0.2)",
    img: "https://storage.readdy-site.link/project_files/362f3206-c32d-4165-9763-523bbd9d0cd3/b3b4cd0a-47d4-4238-a67f-41ff37eb1e8a_-2026-03-22-202437.png?v=55ed0c3f34d36f1f7a235ea25544d94f",
    desc: "기술로 예술가의 가능성을 현실로 만드는 빌더. 플랫폼, 자동화, 데이터 — 아티스트가 창작에만 집중할 수 있는 인프라를 설계합니다.",
  },
];

const stats = [
  { value: "2022", label: "설립 연도", color: "text-brand-purple" },
  { value: "200+", label: "파트너 아티스트", color: "text-brand-teal" },
  { value: "₩42B+", label: "누적 IP 거래액", color: "text-brand-orange" },
  { value: "98%", label: "파트너 만족도", color: "text-white" },
];

export default function AboutPage() {
  return (
    <InnerPageLayout>
      {/* Hero */}
      <section className="relative py-24 lg:py-40 px-4 md:px-6 overflow-hidden">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: "radial-gradient(ellipse at 40% 50%, rgba(168,85,247,0.1) 0%, transparent 65%)" }}
        />
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-purple mb-6 px-3 py-1 rounded-full border border-brand-purple/30 bg-brand-purple/5">
              About ARTREPRENEUR
            </span>
            <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-snug lg:leading-relaxed">
              우리는 예술가의<br />
              <span className="gradient-text-brand">꿈을 현실로</span><br />
              만듭니다.
            </h1>
            <p className="mt-8 text-base md:text-lg text-white/60 font-body leading-loose max-w-2xl">
              아르트레너는 2022년, 재능은 넘치지만 비즈니스 인프라가 없어 꿈을 접어야 했던 아티스트들을 위해 만들어졌습니다.
              우리는 창작 IP를 스케일업 가능한 기업으로 전환하는 프리미엄 컴퍼니빌더입니다.
            </p>
          </div>

          {/* Stats Row */}
          <div className="mt-16 lg:mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-10">
            {stats.map((s) => (
              <div
                key={s.label}
                className="glass rounded-2xl p-6 lg:p-8 flex flex-col gap-2"
              >
                <span className={`font-display text-3xl lg:text-4xl font-bold ${s.color}`}>{s.value}</span>
                <span className="text-sm text-white/40 font-body">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 lg:py-32 px-4 md:px-6" style={{ background: "linear-gradient(180deg, #06080F 0%, #0A0B16 100%)" }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-teal mb-5 px-3 py-1 rounded-full border border-brand-teal/30 bg-brand-teal/5">
                Our Mission
              </span>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-snug lg:leading-relaxed mb-7">
                모든 아티스트는<br />
                <span className="gradient-text-brand">CEO가 될 수 있다.</span>
              </h2>
              <p className="text-white/60 font-body text-base leading-loose mb-6">
                한국의 예술 생태계에는 역설이 있습니다. 세계적 수준의 아티스트는 넘쳐나지만, 그들이 지속 가능하게 창작 활동을 이어갈 수 있는 비즈니스 구조는 턱없이 부족합니다.
              </p>
              <p className="text-white/60 font-body text-base leading-loose">
                아르트레너는 이 간극을 메웁니다. 자본, 기술, 법무, 마케팅 — 아티스트가 홀로 감당하기 어려운 모든 것을 우리가 함께 짊어집니다. 아티스트는 오직 창작에만 집중하면 됩니다.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/415df56ed51e4344ca314ccd39ea0643.jpg"
                alt="아르트레너 미션"
                className="w-full h-80 lg:h-96 object-cover object-top rounded-3xl"
              />
              <div className="absolute inset-0 rounded-3xl" style={{ background: "linear-gradient(135deg, rgba(168,85,247,0.15), transparent)" }} />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 lg:py-32 px-4 md:px-6 bg-brand-bg">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14 lg:mb-20">
            <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-orange mb-5 px-3 py-1 rounded-full border border-brand-orange/30 bg-brand-orange/5">
              Core Values
            </span>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-snug">
              우리가 일하는 방식
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-7">
            {values.map((v) => (
              <div
                key={v.title}
                className="glass rounded-2xl p-6 lg:p-8 flex flex-col gap-5"
                style={{ border: `1px solid ${v.color}18` }}
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: v.glow, border: `1px solid ${v.color}30` }}>
                  <i className={`${v.icon} text-xl`} style={{ color: v.color }} />
                </div>
                <h3 className="font-display text-lg font-bold text-white">{v.title}</h3>
                <p className="text-white/50 text-sm font-body leading-loose">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 lg:py-32 px-4 md:px-6" style={{ background: "linear-gradient(180deg, #06080F 0%, #080B14 100%)" }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14 lg:mb-20">
            <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-purple mb-5 px-3 py-1 rounded-full border border-brand-purple/30 bg-brand-purple/5">
              Builder Team
            </span>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-snug lg:leading-relaxed">
              아티스트 곁에 서는<br />
              <span className="gradient-text-purple">전문가들</span>
            </h2>
            <p className="mt-5 text-white/50 font-body text-base max-w-xl mx-auto leading-loose">
              각 분야 최고의 전문가들이 당신의 비즈니스를 함께 만들어갑니다.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 lg:gap-12 max-w-3xl mx-auto">
            {team.map((member) => (
              <div key={member.name} className="glass rounded-2xl overflow-hidden" style={{ border: `1px solid ${member.border}` }}>
                <div className="w-full h-72 overflow-hidden">
                  <img
                    src={member.img}
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 lg:p-8">
                  <h3 className="font-display text-xl font-bold text-white">{member.name}</h3>
                  <p className="text-sm font-display font-medium mt-1 mb-4" style={{ color: member.color }}>{member.role}</p>
                  <p className="text-white/55 text-sm font-body leading-loose">{member.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 lg:py-32 px-4 md:px-6 bg-brand-bg text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-6 leading-snug lg:leading-relaxed">
            함께 만들어갈 준비가<br />
            <span className="gradient-text-brand">되셨나요?</span>
          </h2>
          <p className="text-white/50 font-body text-base mb-10 leading-loose">
            지금 아르트레너 진단을 시작하고, 아르트레너 빌더팀과 첫 미팅을 잡아보세요.
          </p>
          <a
            href="/#canvas"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-display font-semibold text-white cursor-pointer whitespace-nowrap transition-all duration-300"
            style={{ background: "linear-gradient(135deg, #A855F7, #7C3AED)", boxShadow: "0 0 30px rgba(168,85,247,0.35)" }}
          >
            <i className="ri-flashlight-line" />
            아르트레너 진단 시작하기
          </a>
        </div>
      </section>
    </InnerPageLayout>
  );
}
